import { serializeQuery } from "@xtribe/shared/lib/text-transformations";
import { Space, TaxRates } from "@prisma/client";
import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { FecthStripeTaxRatesProps } from "./types";
import Stripe from "stripe";
async function fetchStripeTaxRates({
  teamId,
  active,
  skip,
  take,
}: FecthStripeTaxRatesProps): Promise<Stripe.TaxRate[]> {
  const query = serializeQuery({ teamId, active, skip, take });
  try {
    const res = await axios.get(
      `/api/stripe/connect/taxRates/list${query ? "?" + query : ""}`
    );
    return res.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      throw new Error(error?.response?.data?.message);
    } else throw error;
  }
}

function useStripeTaxRates<TData = Stripe.TaxRate[]>(
  { teamId, take, skip, active }: FecthStripeTaxRatesProps,
  options?: UseQueryOptions<Stripe.TaxRate[], AxiosError, TData>
) {
  return useQuery(
    ["stripeTaxRates", { teamId, active, skip, take }],
    () => fetchStripeTaxRates({ teamId, active, skip, take }),
    options
  );
}

async function fetchTaxRates({
  teamId,
  active,
  skip,
  take,
}: FecthStripeTaxRatesProps): Promise<TaxRates[]> {
  const query = serializeQuery({ teamId, active, skip, take });
  try {
    const res = await axios.get(
      `/api/v1/tax-rates/list${query ? "?" + query : ""}`
    );
    return res.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      throw new Error(error?.response?.data?.message);
    } else throw error;
  }
}

function useTaxRates<TData = TaxRates[]>(
  { teamId, take, skip, active }: FecthStripeTaxRatesProps,
  options?: UseQueryOptions<TaxRates[], AxiosError, TData>
) {
  return useQuery(
    ["stripeTaxRates", { teamId, active, skip, take }],
    () => fetchTaxRates({ teamId, active, skip, take }),
    options
  );
}

export { useStripeTaxRates, fetchStripeTaxRates, useTaxRates, fetchTaxRates };
